var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"session-expired"},[_c('img',{attrs:{"src":_vm.getImage('error.svg'),"alt":"SE"}}),_c('h1',[_vm._v("This session has expired")]),_c('el-button',{attrs:{"type":"primary","disabled":""}},[_vm._v("Reload")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }